import Big from 'big.js'

import { CurrentPayment } from 'Invoices/types'

/**
 * Total currently applied payments on an invoice, as a major-unit decimal
 * string. Uses Big.js to avoid floating-point drift.
 */
export const sumCurrentPayments = (
  payments: ReadonlyArray<Pick<CurrentPayment, 'amount'>> = []
): string =>
  payments
    .reduce((sum, payment) => sum.plus(payment.amount), new Big(0))
    .toString()
